import { render, staticRenderFns } from "./ActivityNotifyForm.vue?vue&type=template&id=32415e9a&scoped=true&"
import script from "./ActivityNotifyForm.vue?vue&type=script&lang=js&"
export * from "./ActivityNotifyForm.vue?vue&type=script&lang=js&"
import style0 from "./ActivityNotifyForm.vue?vue&type=style&index=0&id=32415e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32415e9a",
  null
  
)

export default component.exports